var map = {
	"./article-create.svg": 85530,
	"./article-ranking.svg": 95853,
	"./article.svg": 38562,
	"./assessment-record.svg": 37219,
	"./change-theme.svg": 14133,
	"./credit-limit.svg": 52884,
	"./dashboard.svg": 58749,
	"./example.svg": 49892,
	"./exit-fullscreen.svg": 80871,
	"./eye-open.svg": 14301,
	"./eye.svg": 34986,
	"./find.svg": 57458,
	"./fullscreen.svg": 16286,
	"./gas-station.svg": 38397,
	"./glass-0.svg": 95297,
	"./glass-blue-2.svg": 40449,
	"./glass-blue-3.svg": 44653,
	"./glass-blue-4.svg": 73776,
	"./glass-blue-5.svg": 85630,
	"./glass-red-2.svg": 35115,
	"./glass-red-3.svg": 84499,
	"./glass-red-4.svg": 91422,
	"./glass-red-5.svg": 66663,
	"./goods-classify.svg": 27080,
	"./guide.svg": 55860,
	"./hamburger-closed.svg": 70149,
	"./hamburger-opened.svg": 6929,
	"./help.svg": 9977,
	"./international.svg": 13906,
	"./introduce.svg": 46513,
	"./language.svg": 59424,
	"./link.svg": 14121,
	"./nested.svg": 91476,
	"./org-account.svg": 5476,
	"./org-permission.svg": 19315,
	"./org-personnel-manage.svg": 22499,
	"./org-personnel.svg": 72877,
	"./org-role.svg": 25751,
	"./org-shop.svg": 55617,
	"./org-us-price.svg": 32122,
	"./password.svg": 46408,
	"./personnel-info.svg": 43257,
	"./plaint.svg": 55732,
	"./platform-classify.svg": 84280,
	"./raw-material.svg": 26845,
	"./reward.svg": 21907,
	"./search.svg": 42042,
	"./shop-after-sales-done-start.svg": 44107,
	"./shop-after-sales-manage.svg": 53150,
	"./shop-after-sales-pending-start.svg": 81152,
	"./shop-after-sales-pending-unstart.svg": 92409,
	"./shop-after-sales-pendingrefund-start.svg": 17543,
	"./shop-after-sales-pendingrefund-unstart.svg": 2066,
	"./shop-after-sales-refund-start.svg": 90327,
	"./shop-after-sales-reject-start.svg": 98435,
	"./shop-cashier-management.svg": 57098,
	"./shop-cert-address.svg": 31825,
	"./shop-cert-code.svg": 51864,
	"./shop-cert-ein.svg": 52927,
	"./shop-cert-email.svg": 50856,
	"./shop-cert-name.svg": 25719,
	"./shop-cert-phone.svg": 82066,
	"./shop-cert-service.svg": 94675,
	"./shop-cert-ubi.svg": 15079,
	"./shop-cert-url.svg": 97074,
	"./shop-close.svg": 55896,
	"./shop-goods-list-info.svg": 617,
	"./shop-goods-manage.svg": 30387,
	"./shop-goods-measure-unit.svg": 23059,
	"./shop-goods.svg": 53916,
	"./shop-index.svg": 80105,
	"./shop-ok.svg": 10497,
	"./shop-online-goods-manage.svg": 3899,
	"./shop-order-delete-sku.svg": 28144,
	"./shop-order-manage.svg": 16091,
	"./shop-order-peisong.svg": 6989,
	"./shop-order-switch-cashier.svg": 9999,
	"./shop-order-switch.svg": 3404,
	"./shop-order-xianxia.svg": 83776,
	"./shop-order-ziti.svg": 11163,
	"./shop-push-goods.svg": 19392,
	"./shop-setting.svg": 61870,
	"./shop-shop-manage.svg": 11864,
	"./shop-stock-manage.svg": 96955,
	"./shop-wallet-coin.svg": 11584,
	"./shop-wallet-diya.svg": 62846,
	"./shop-wallet-manage.svg": 40891,
	"./shop-wallet-manage1.svg": 28719,
	"./shop-wallet.svg": 23605,
	"./shop-warn.svg": 48197,
	"./table.svg": 3797,
	"./tree.svg": 40964,
	"./user.svg": 30042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;